import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {WidgetData} from '../../../../../core/shared/widget/widget-data';
import {FilterCriteria} from '../../../../../core/shared/filter/api/filter.criteria';
import {WidgetFactory} from '../../../../../core/shared/widget/service/widget.factory';
import {ObjectRequestList} from '../../../../../core/shared/dto/object/request/object-request-list';
import {ObjectIdentifierData} from '../../../../../core/shared/basic/object-identifier-data';
import {ObjectIdentifier} from '../../../../../core/shared/basic/object-identifier';

@Component({
    selector: 'jb-single-job-batch-overview-component',
    templateUrl: 'jb-single-job-batch-overview.component.html',
    standalone: false
})
export class JbSingleJobBatchOverviewComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    jobName: string;

    singleJobDataReportWidget: WidgetData;
    singleJobOverviewReportWidget: WidgetData;

    selectedInstance: number;

    constructor(protected route: ActivatedRoute) {
    }

    ngOnInit(): void {
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.route.paramMap.subscribe(params => {
            this.jobName = params.get('jobId');

            this.refreshComponent();
        });

    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.refreshReportWidget();
        this.initialized = true;
    }

    refreshReportWidget(statusKey?: number) {

        const filterCriteria = FilterCriteria.create('job_name', FilterCriteria.cOperatorEqual, this.jobName);

        this.singleJobDataReportWidget = WidgetFactory.createWidget(
            'jb.job.details.report.widget',
            'Job Details',
            'list',
            'list',
            'report',
            'jb.run.1'
        );

        this.singleJobDataReportWidget.dataProviderListRequest = ObjectRequestList.createBasic(true, [filterCriteria], []);

        this.singleJobOverviewReportWidget = WidgetFactory.createWidget(
            'jb.single.job.overview.report.table.widget',
            'Job Overview',
            'table',
            'list',
            'report',
            'jb.run.2'
        );

        this.singleJobOverviewReportWidget.dataProviderListRequest = ObjectRequestList.createBasic(true, [filterCriteria], []);
    }

    handleObjectSelect(object: ObjectIdentifierData | ObjectIdentifier) {
        this.selectedInstance = object.objectId;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes['id']) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
